import {
  GET_LIST_CAUHINHGOITRAGOP,
  GET_LIST_CAUHINHGOITRAGOP_SUCCESS,
  GET_LIST_CAUHINHGOITRAGOP_FAILURE,
  UPDATE_SEARCHTDATA_CAUHINHGOITRAGOP,
} from "./actionTypes";

export const getListCauHinhGoiTraGop = (dataSearch) => ({
  type: GET_LIST_CAUHINHGOITRAGOP,
  dataSearch,
});
export const getListCauHinhGoiTraGopSuccess = (data) => ({
  type: GET_LIST_CAUHINHGOITRAGOP_SUCCESS,
  payload: data,
});
export const getListCauHinhGoiTraGopFailure = (dataSearch) => ({
  type: GET_LIST_CAUHINHGOITRAGOP_FAILURE,
});
export const updateDataSearch = (data) => ({
  type: UPDATE_SEARCHTDATA_CAUHINHGOITRAGOP,
  payload: data,
});
